import React from 'react';
import { SearchInput } from '@features/SearchInput';
import { useAccountsTable } from '../../lib';
import './AccountsTableFilters.scss';

export const AccountsTableFilters: React.FC = () => {
    const { setCan, setFdid } = useAccountsTable();

    return (
        <div className='widget-accounts-table-filters'>
            <SearchInput
                setValue={setCan}
                queryName='clearingAccount'
                placeholder='Account Number'
            />
            <SearchInput
                setValue={setFdid}
                queryName='fdid'
                placeholder='FDID'
            />
        </div>
    );
};
